import { render, staticRenderFns } from "./professionalDetail.vue?vue&type=template&id=776d2bad&scoped=true&"
import script from "./professionalDetail.vue?vue&type=script&lang=js&"
export * from "./professionalDetail.vue?vue&type=script&lang=js&"
import style0 from "./professionalDetail.vue?vue&type=style&index=0&id=776d2bad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d2bad",
  null
  
)

export default component.exports